import { graphql } from "gql.tada";
import { LinkFragment } from "./fragments/LinkFragment";

export const GetCookieSettings = graphql(
  /* GraphQL */ `
    query GetCookieSettings($locale: String, $preview: Boolean) {
      cookieFooterCollection(locale: $locale, preview: $preview, limit: 1) {
        items {
          cookiesText
          termsAndConditions {
            ...LinkFragment
          }
        }
      }
    }
  `,
  [LinkFragment]
);
